import Axios from "axios"
import {getAccessToken, getRefreshToken} from "../AuthServices"
import {getLocalData} from "../StorageServices";

const _store = {
    errorSubscribers: []
}

const _makeRequest = createRequest => async args => {
    const _headers = args.headers ? args.headers : {}

    const defaultHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'cache-control': 'no-cache'
    }

    args = {
        ...args,
        headers: {
            ...defaultHeaders,
            ..._headers
        },
    }

    try {
        const resp = await createRequest(args)
        const {data} = resp
        return data
    } catch (e) {
        throw e
    }
}

const _makeRequestQueue = createRequest => async args => {
    const _headers = args.headers ? args.headers : {}
    const authorizationLocal = getLocalData('apiKey')

    const defaultHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
        'Authorization': authorizationLocal
    }

    args = {
        ...args,
        headers: {
            ...defaultHeaders,
            ..._headers
        },
    }

    try {
        const resp = await createRequest(args)
        const {data} = resp
        return data
    } catch (e) {
        throw e
    }
}

const _makeRequestFull = createRequest => async args => {
    const _headers = args.headers ? args.headers : {}

    const defaultHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Authorization': "pgrtbawjcogalovyrjcytrtr"
        //'cache-control': 'no-cache',
    }

    args = {
        ...args,
        headers: {
            ...defaultHeaders,
            ..._headers
        },
    }

    try {
        const resp = await createRequest(args)
        return resp
    } catch (e) {
        throw e
    }
}

const _makeAuthRequest = createRequest => async (args) => {
    const requestHeaders = args.headers ? args.headers : {}
    const accessToken = getAccessToken()
    const refreshToken = getRefreshToken()

    let headers = {
        'Authorization': `Bearer ${accessToken}`,
        'cache-control': 'no-cache',
    }

    if (refreshToken) {
        headers['X-Refresh-Token'] = refreshToken
    }

    args = {
        ...args,
        headers: {
            ...headers,
            ...requestHeaders
        }
    }

    try {
        return await _makeRequest(createRequest)(args)
    } catch (error) {
        const {response} = error

        if (!response || typeof response !== 'object') {
            throw error
        }

        const {status, data} = response
        if (status) {
            _store.errorSubscribers.forEach(subscriber => {
                subscriber({status, data})
            })
        }

        throw error
    }
}

const _subscribeErrorRequest = instance => (subscriber = null) => {
    if (!subscriber || typeof subscriber !== 'function') return false
    if (_store.errorSubscribers.indexOf(subscriber) !== -1) return false

    _store.errorSubscribers = [].concat(_store.errorSubscribers, [subscriber])
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (options = {}) => {
    const baseUrlValidated = options.baseUrl || '/api'
    const headers = Object.assign({}, options.headers)
    const timeoutValidated = options.timeout || 30000

    const instance = Axios.create({
        baseURL: baseUrlValidated,
        timeout: timeoutValidated,
        headers,
        validateStatus: function (status) {
            return status >= 200 && status <= 400
        },
        onUploadProgress: options.onUploadProgress
    })

    const _changeBaseURL = (baseURL) => {
        instance.defaults.baseURL = baseURL
    }

    const _getBaseURL = () => {
        return instance.defaults.baseURL
    }

    const _setDefault = (property, value = null) => {
        instance.defaults[property] = value
    }

    return {
        setDefault: _setDefault,
        getBaseURL: _getBaseURL,
        changeBaseURL: _changeBaseURL,
        makeRequest: _makeRequest(instance),
        makeRequestQueue: _makeRequestQueue(instance),
        makeRequestFull: _makeRequestFull(instance),
        makeAuthRequest: _makeAuthRequest(instance),
        subscribeErrorRequest: _subscribeErrorRequest(instance),
    }
}

